import { Filter, FilterGroup } from '@/types/filter';

export function resetFilterInFilterGroup(filterGroup: FilterGroup, filter: Filter): FilterGroup {
  const searchedFilter = filterGroup.values.find((groupFilter) => groupFilter.value === filter.value);

  if (searchedFilter) {
    searchedFilter.selected = false;
  }

  return filterGroup;
}

export function resetFilterInFilterGroupList(
  filterGroupList: FilterGroup[],
  filterGroup: FilterGroup,
  filter: Filter,
): FilterGroup[] {
  filterGroupList.forEach((group) => {
    if (group.fieldname === filterGroup.fieldname) {
      resetFilterInFilterGroup(group, filter);
    }
  });

  return filterGroupList;
}

export function resetAllFilters(filterGroupList: FilterGroup[]): FilterGroup[] {
  filterGroupList.forEach((group) => {
    group.values.forEach((filter) => {
      filter.selected = false;
    });
  });

  return filterGroupList;
}

export function getFilterGroupsWithSelection(filterGroups: FilterGroup[]): FilterGroup[] {
  if (!filterGroups?.length) {
    return [];
  }

  return filterGroups.reduce((selectedGroups: FilterGroup[], currentGroup: FilterGroup) => {
    const selectedValues = currentGroup.values?.filter((filter) => filter.selected);

    if (selectedValues && selectedValues.length > 0) {
      selectedGroups.push({
        ...currentGroup,
        values: selectedValues,
      });
    }

    return selectedGroups;
  }, []);
}

export function updateFilterGroupsForFe(filterGroups: FilterGroup[]): FilterGroup[] {
  if (!filterGroups?.length) {
    return [];
  }

  filterGroups.forEach((filterGroup) => {
    filterGroup.hasSelectedValues = !!filterGroup.values?.find((filter) => filter.selected);
  });

  return filterGroups;
}
